import { useMemo } from 'react';

import { commonApi } from '@internal/api/common';

const useLocationCountry = () => {
  const { location } = commonApi.getLocation.useQuery();
  const { constants } = commonApi.getConstants.useQuery();

  const country = useMemo(() => {
    if (!location?.country || !constants) {
      return null;
    }

    const locationCountry = Object.entries(constants.countriesData || {}).find(
      ([name, { code }]) =>
        code === location.country || name === location.country
    )?.[0];

    return locationCountry || null;
  }, [location, constants]);

  return { country };
};

export default useLocationCountry;
